const signInEN = {
	title: "Sign In",
	subtitle: "Manage your bookings, your calendar and your team.",
	email: "Email",
	password: "Password",
	rememberMe: "Remember me",
	button: "Sign In",
	loading: "Signing in...",
	forgotPassword: "Forgot password?",
	noAccount: "Don’t have an account?",
	createCustomer: "Create a customer account",
	createCustomerDesc: "Book appointments and skip the line",
	registerBusiness: "Register your business",
	registerBusinessDesc: "Take bookings online, free for 14 days",
	secureNote: "Your details are encrypted in transit",
	sessionExpired: "Your session expired. Please sign in again.",
};
export default signInEN;